import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List, Map } from "immutable";
import numeral from "numeral";
import moment from 'moment';
import Auth from '../../../lib/auth';

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import Select from "../../../components/common/virtualized-select";

// Actions
import { getYears, cleanYears } from '../../../actions/years';
import { getPurchaseInvoices, changePurchaseInvoiceStatus, cleanPurchaseInvoices } from "../../../actions/purchase-invoices";

// Numeral configuration
import 'numeral/locales/es-es'
import Loading from '../../../components/common/Loading';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'invoice_code document_date expiration_date supplier statistics.subtotal statistics.vat statistics.total status',
    populateRefs: [{
        field: 'supplier',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'purchase-invoices'
};

class PurchaseInvoicesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            purchaseInvoiceFilters: '',
            selectedYear: Auth.getSelectedYear(),
            purchaseInvoicesIsFetching: false
        };
    }

    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getPurchaseInvoices(queryOptions);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getPurchaseInvoices(queryOptions);
        }
    }

    componentWillUnmount() {
        this.props.cleanPurchaseInvoices();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            document_date: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        let tableData = this.props.purchaseInvoices;
        const purchaseInvoicesIsFetching = this.props.purchaseInvoicesIsFetching;

        // Filters Zone
        let totalInvoices = 0, totalUnpaid = 0;
        this.props.purchaseInvoices.forEach(invoice => {
            if (invoice.get('status') === 'unpaid') {
                totalUnpaid = totalUnpaid + invoice.getIn(['statistics', 'total']);
            }
            totalInvoices = totalInvoices + invoice.getIn(['statistics', 'total']);
        });
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label ">{ numeral(totalInvoices).format() }</span>
                    <span>Total facturas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                    <span>Total pendiente</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.purchaseInvoices.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }><strong>Facturas</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }>Pagadas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                </div>
            </div>
        );

        switch (this.state.purchaseInvoiceFilters) {
            case 'paid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }><strong>Pagadas</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseInvoices.filter( purchaseInvoice => purchaseInvoice.get('status') === 'paid' );
                break;
            case 'unpaid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'paid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'paid' }) }>Pagadas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.purchaseInvoices.count(invoice => invoice.get('status') === 'unpaid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseInvoiceFilters: 'unpaid' }) }><strong>Pendientes</strong></span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseInvoices.filter( purchaseInvoice => purchaseInvoice.get('status') === 'unpaid' );
                break;
            default:
                break;
        }

        // PurchaseInvoices Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            invoice_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'invoice_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/facturas/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expiration_date: {
                title: "Fecha de vencimiento",
                columnType: 'date',
                dataField: 'expiration_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'unpaid':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'paid':
                            data.badgeColor = 'primary';
                            data.value = 'Pagado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let popoverContent = (<Menu></Menu>);
                    switch (value[1]) {
                        case 'unpaid':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/facturas/' + value[0])} />
                                    <MenuItem icon="swap" text="Pagado" onClick={ () => this.props.changePurchaseInvoiceStatus(value[0], 'paid', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'paid':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/facturas/' + value[0])} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changePurchaseInvoiceStatus(value[0], 'unpaid', queryOptions) } />
                                </Menu>
                            );
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper binvoice-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Facturas</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/compras/facturas/nuevo') } > <Icon icon="insert"/>Factura</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    {purchaseInvoicesIsFetching ? (
                                        <Loading show={purchaseInvoicesIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const purchaseInvoicesReducer = state.purchaseInvoices;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // PurchaseInvoices
    let purchaseInvoices = purchaseInvoicesReducer.get('payload') || List([]);
    const purchaseInvoicesIsFetching = purchaseInvoicesReducer.get('isFetching');

    if (!(purchaseInvoices instanceof List)) {
        purchaseInvoices = List([])
    }

    return {
        years,
        purchaseInvoices,
        purchaseInvoicesIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getPurchaseInvoices: (query) => dispatch(getPurchaseInvoices(query)),
        changePurchaseInvoiceStatus: (purchaseInvoiceId, status, options) => dispatch(changePurchaseInvoiceStatus(purchaseInvoiceId, status, options)),
        cleanYears: () => dispatch(cleanYears()),
        cleanPurchaseInvoices: () => dispatch(cleanPurchaseInvoices())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseInvoicesPage);


// WEBPACK FOOTER //
// ./src/containers/purchases/invoices/PurchaseInvoicesPage.js